import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { AppSharedService } from '../../services/app-shared.service';
import { AppInstallService } from '../../services/app-install.service';


@Component({
    selector: 'app-install',
    imports: [],
    templateUrl: './install.component.html',
    styleUrls: ['./install.component.scss']
})
export class InstallComponent implements OnInit, OnDestroy {
  installable = false;
  iosPrompt = false;
  tennant = 'ashi';
  private installCheck?: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appShared: AppSharedService,
    private appInstall: AppInstallService
  ) {}

  ngOnInit(): void {
    // iOS detection
    this.iosPrompt =
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

    this.appInstall.installable$.subscribe(install => {
      this.installable = install;
    });

    this.installCheck = interval(1000).subscribe(() => {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        this.appInstall.setInstallable(false);
        this.router.navigate(['/', this.appShared.tennant, 'login']);
      }
    });
  }

  ngOnDestroy(): void {
    this.installCheck?.unsubscribe();
  }

  installApp(): void {
    this.appInstall.installApp();
  }
}